import { SimpleSocialLanding } from "@/components/SimpleSocialLanding";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

const Lifestyle = () => (
  <SimpleSocialLanding
    seoPageKey="lifestyle"
    i18nPrefix="simplePages.lifestyle"
    imageAlt={`${BRAND_PERSON_NAME} - Lifestyle content creator portrait photo`}
  />
);

export default Lifestyle;
